import queryString from 'query-string';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  ADMIN: {
    DOWNLOAD_USER_CPD_PROGRESS_REPORT: (filter) => ({ filter }),
    API: {
      DOWNLOAD_USER_CPD_PROGRESS_REPORT: apiResourceActionCreator('report')
    }
  }
})

export const apiAction = (authToken, filter) => commonApiActions.authenticated.get(`${API_ENDPOINT}/reports/users/cpd-progress?${queryString.stringify(filter)}`, authToken, action.admin.api.downloadUserCpdProgressReport)

function* downloadUserCpdProgressReport(action) {
  const authToken = yield select(authTokenSelector);

  yield put(apiAction(authToken, action.payload.filter));
}

const configuration = {
  name: 'downloadUserCpdProgressReport',
  action: action,
  sagas: downloadUserCpdProgressReport,
  reducers: {
    request: (state, action) => ({
      ...state,
      isDownloadingUserCpdProgressReport: true
    }),
    success: (state, action) => {
      const { total, skip, take } = action.payload.report;

      const existingUserStats = state.report !== undefined && state.report.downloadedUserCpdProgressReport !== undefined ? 
        state.report.downloadedUserCpdProgressReport.usersCpdStats : [];

      const existingUsersCpdCategorySearchTiles = state.report !== undefined && state.report.downloadedUserCpdProgressReport !== undefined ? 
        state.report.downloadedUserCpdProgressReport.usersCpdCategorySearchTiles : [];

      return {
        ...state,
        isDownloadingUserCpdProgressReport: false,
        report: {
          ...(state.report || {}),
          downloadedUserCpdProgressReport: {
            total,
            skip,
            take,
            usersCpdStats: [
              ...existingUserStats,
              ...action.payload.report.usersCpdStats
            ],
            usersCpdCategorySearchTiles: [
              ...existingUsersCpdCategorySearchTiles,
              ...action.payload.report.usersCpdCategorySearchTiles
            ]
          }
        }
      };
    },
    failed: (state, action) => ({
      ...state,
      isFetchingReport: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/downloadUserCpdProgressReport.js